import { getZrmListingInfo, getZrmRentalsLead, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackListingEvent, trackUserEvent } from '../../analytics';
import {
  type ClickstreamEventParams,
  SEMANTIC_EVENT_NAME,
  TOPIC_TAG_TXT,
  TRIGGER_LOCATION,
  TRIGGER_TYPE,
} from './globals';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

const MESSAGE_WINDOW = 'message_window';

// https://dataportal.zillowgroup.net/event-registry/3368
export const RENTER_PROFILE_CHAT_BUBBLE_ABOUT_ME_CLICK_EVENT_TYPE_ID = '3368';
export const emitRenterProfileChatBubbleAboutMeClickEvent = ({
  user,
  listing,
  triggerLocation,
  lead,
}: ClickstreamEventParams) =>
  trackListingEvent({
    envelope: {
      event_type_id: RENTER_PROFILE_CHAT_BUBBLE_ABOUT_ME_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '3',
      event_template_id: '628',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: triggerLocation,
      trigger_source_nm: 'about_me_link',
      trigger_object_nm: MESSAGE_WINDOW,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewRenterProfile,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
    ...getZrmListingInfo(listing),
    ...getZrmRentalsLead(lead),
  });

// https://dataportal.zillowgroup.net/event-registry/3370
export const RENTER_PROFILE_MOBILE_ICON_CLICK_EVENT_TYPE_ID = '3370';
export const emitRenterProfileMobileIconClickEvent = (user: ZrmClickstreamUserOrNull) =>
  trackUserEvent({
    envelope: {
      event_type_id: RENTER_PROFILE_MOBILE_ICON_CLICK_EVENT_TYPE_ID,
      event_type_version_id: '1',
      event_template_id: '167',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_type_nm: TRIGGER_TYPE.Interaction,
      trigger_location_nm: TRIGGER_LOCATION.IreneInbox,
      trigger_source_nm: 'mobile_web_renter_profile_icon',
      trigger_object_nm: MESSAGE_WINDOW,
    },
    semantic: {
      semantic_event_nm: SEMANTIC_EVENT_NAME.ViewRenterProfile,
      topic_tag_txt: [TOPIC_TAG_TXT.ZrmSatellite],
    },
    ...getZrmUserInfo(user),
  });
